import React from 'react';
import Icon4 from "../../../images/ServiceIcons/bar-chart (1).svg";
import OurServiceCardContainer from '../../OurServices/OurServiceCardContainer';




export default function PPNFeatures({title, services}) {
    const ABNServices = [
   
      {
        image: Icon4,
        title: " Real Time Visibility",
        bodycopy:
          " Real-time visibility in manufacturing offers a crucial benefit for food processing enterprise customers, enabling them to optimize operations, track production progress, and respond promptly to any issues, thus enhancing efficiency and productivity."
      },
      {
        image: Icon4,
        title: " Developer Quality Assistant ( Plant QA) for ensured quality ",
        bodycopy:
          "Developer Quality Assistant (Plant QA) is a service provided by the Plant Production Network, optimizing software development processes and ensuring high-quality outcomes through advanced tools and methodologies."
      },
      {
        image: Icon4,
        title: "Plant Production KPI visualization (P.O Live Status Monitoring)",
        bodycopy:
          "Plant production KPI visualization for live status monitoring is a service provided by the Plant Production Network, enabling real-time tracking and informed decision-making to enhance operational efficiency and productivity."
      },
      {
        image: Icon4,
        title: " Traceability & Provenance By Operator",
        bodycopy:
          " Traceability and provenance by operator as a service ensures transparent asset tracking, leveraging advanced tech for reliability and compliance, fostering trust, and optimizing operations.            "
      },
          
      ];
  return (
    <OurServiceCardContainer services={ABNServices} title={title}/>
  )
}
